import React from "react";
import styles from "./CompliancesAndCertifications.module.scss";
import LogoImageContainer from "./LogoImageContainer";
import { getCDNImageUrl } from "@/utils/Common";

function CompliancesAndCertifications() {
  return (
    <div className={styles.compliancesAndCertifications}>
      <div className={styles.headings}>
        {/* Small Heading */}
        <h6>ELCHEMY ADVANTAGE</h6>
        {/* Big Heading */}
        <h2>
          Compliances and <br />
          Certifications
        </h2>
      </div>
      <div className={styles.certifications}>
        {/* Desktop Layout */}
        <div className={styles.desktopLayout}>
          {/* Row of Certifications */}
          <div className={styles.row}>
            <LogoImageContainer
              src={getCDNImageUrl("fda.webp")}
              alt="FDA Certification"
            />
            <LogoImageContainer
              src={getCDNImageUrl("GMP.webp")}
              alt="GMP Certification"
              width={90}
              height={90}
            />
            <LogoImageContainer
              src={getCDNImageUrl("WHO.webp")}
              alt="WHO Certification"
              width={90}
              height={90}
            />
            <LogoImageContainer
              src={getCDNImageUrl("FDA2.webp")}
              alt="FDA Certification"
              width={90}
              height={90}
            />
          </div>
          {/* Row of Certifications */}
          <div className={styles.row}>
            <LogoImageContainer
              src={getCDNImageUrl("ISO1.webp")}
              alt="ISO Certification"
              width={90}
              height={90}
            />
            <LogoImageContainer
              src={getCDNImageUrl("ISO2.webp")}
              alt="ISO Certification"
              width={90}
              height={90}
            />
            <LogoImageContainer
              src={getCDNImageUrl("ISO3.webp")}
              alt="ISO Certification"
              width={90}
              height={90}
            />
            <LogoImageContainer
              src={getCDNImageUrl("FDCA.webp")}
              alt="FDCA Certification"
              width={90}
              height={90}
            />
          </div>

          {/* Row of Certifications */}
          <div className={styles.row}>
            <LogoImageContainer
              src={getCDNImageUrl("WHOGMP.webp")}
              alt="WHOGMP Certification"
              width={90}
              height={90}
            />
            <LogoImageContainer
              src={getCDNImageUrl("HALAL.webp")}
              alt="HALAL Certification"
              width={90}
              height={90}
            />
            <LogoImageContainer
              src={getCDNImageUrl("KOSHER.webp")}
              alt="KOSHER Certification"
              width={90}
              height={90}
            />
          </div>
        </div>

        {/* Mobile Layout - Rows of 2 */}
        <div className={styles.mobileLayout}>
          <div className={styles.row}>
            <LogoImageContainer src="fda.png" alt="FDA Certification" />
            <LogoImageContainer
              src={getCDNImageUrl("GMP.webp")}
              alt="GMP Certification"
              width={90}
              height={90}
            />
          </div>
          <div className={styles.row}>
            <LogoImageContainer
              src={getCDNImageUrl("WHO.webp")}
              alt="WHO Certification"
              width={90}
              height={90}
            />
            <LogoImageContainer
              src={getCDNImageUrl("FDA2.webp")}
              alt="FDA Certification"
              width={90}
              height={90}
            />
          </div>
          <div className={styles.row}>
            <LogoImageContainer
              src={getCDNImageUrl("ISO1.webp")}
              alt="ISO Certification"
              width={90}
              height={90}
            />
            <LogoImageContainer
              src={getCDNImageUrl("ISO2.webp")}
              alt="ISO Certification"
              width={90}
              height={90}
            />
          </div>
          <div className={styles.row}>
            <LogoImageContainer
              src={getCDNImageUrl("ISO3.webp")}
              alt="ISO Certification"
              width={90}
              height={90}
            />
            <LogoImageContainer
              src={getCDNImageUrl("FDCA.webp")}
              alt="FDCA Certification"
              width={90}
              height={90}
            />
          </div>
          <div className={styles.row}>
            <LogoImageContainer
              src={getCDNImageUrl("WHOGMP.webp")}
              alt="WHOGMP Certification"
              width={90}
              height={90}
            />
            <LogoImageContainer
              src={getCDNImageUrl("HALAL.webp")}
              alt="HALAL Certification"
              width={90}
              height={90}
            />
          </div>
          <div className={styles.row}>
            <LogoImageContainer
              src={getCDNImageUrl("KOSHER.webp")}
              alt="KOSHER Certification"
              width={90}
              height={90}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompliancesAndCertifications;
